import { Tooltip } from '@mantine/core';
import type { UserOut as IUser } from '@repo/api-codegen/v2';
import { useMemo, type PropsWithChildren } from 'react';
import { Link } from 'react-router';

export type AvatarUser = Pick<
	IUser,
	'disabled' | 'id' | 'email' | 'display_name' | 'first_name' | 'last_name'
> & { profile_picture?: string | null };

interface TooltipAvatarProps {
	user: AvatarUser;
	tooltip?: string;
	enableLink?: boolean;
}

export function TooltipAvatar({
	user,
	tooltip,
	enableLink,
	children,
	...props
}: PropsWithChildren<TooltipAvatarProps>) {
	const label = useMemo(() => {
		const userDisplayName = tooltip ?? user.display_name;
		return user?.disabled
			? `Deactivated User: ${userDisplayName}`
			: userDisplayName;
	}, [user, tooltip]);

	return (
		<Tooltip disabled={tooltip === undefined} position="top" label={label}>
			{enableLink ? (
				<Link to={`/user/${user.id}`} {...props}>
					{children}
				</Link>
			) : (
				<div {...props}>{children}</div>
			)}
		</Tooltip>
	);
}
